import { render, staticRenderFns } from "./alarmUserSendConfig.vue?vue&type=template&id=6df66028&scoped=true&"
import script from "./alarmUserSendConfig.vue?vue&type=script&lang=js&"
export * from "./alarmUserSendConfig.vue?vue&type=script&lang=js&"
import style0 from "./alarmUserSendConfig.vue?vue&type=style&index=0&id=6df66028&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df66028",
  null
  
)

export default component.exports